$(document).ready(function () {
  $('.cstm-testimonial-slider').slick({
    dots: true, 
    infinite: true, 
    slidesToShow: 3, // Default number of slides to show
    slidesToScroll: 1, 
    autoplay: true, 
    autoplaySpeed: 3000, 
    arrows: false, 
    adaptiveHeight: true, 
    responsive: [
      {
        breakpoint: 480, 
        settings: {
          slidesToShow: 1, 
          slidesToScroll: 1
        }
      }
    ]
  });
});
